/** 
 * @file /src/components/demo/TranslatedTextDialog.js
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import ISO6391 from 'iso-639-1';

/**
 * @class TranslatedTextDialog
 * @description Modal dialog that shows translated text returned from enrich call
 * @property sourceText - Original text
 * @property sourceLanguage - Source language code
 * @property targetText - Translated Text
 */
class TranslatedTextDialog extends Component {

    /** @constructor */
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);

        this.state = {
            error: '',
            modalOpen: false
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_TranslatedTextDialog');
    }

    /**
     * Close the dialog box
     */
    close() {
        this.setState({
            modalOpen: false
        })
    };

    /**
     * Open the dialog box
     */
    open() {
        this.setState({
            modalOpen: true
        })
    };

    render() {

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '35%',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                transform   : 'translate(-50%, -35%)',
                maxWidth    : '60%',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        var lang = null;
        if (this.props.sourceLanguage) {
            lang = ISO6391.getName(this.props.sourceLanguage);
        }

        return (
           <div id="rm_TranslatedTextDialog">
                <button className="link-button" onClick={this.open}>
                    <span className='fa fa-language'></span>&nbsp;Translated Text
                </button>
                <ReactModal ref="translatedTextId" 
                    isOpen={this.state.modalOpen}
                    contentLabel="TranslatedText"
                    onRequestClose={this.close} 
                    style={styles}
                    closeTimeoutMS={1000}>
                    <div className="translatedText-dialog">
                        <div className="translatedText-header">
                            Translated Text
                        </div>
                        <div className="translatedText-description">
                            <span className='fa fa-language translatedText-icon'>&nbsp;</span>
                            Original enriched text translated to English.    
                        </div>
                        <div className="translatedText-content">
                            <div className="translatedText-form">
                                <div className="translate-results">
                                    <div className="source-text">
                                        <div className='header'>{`Source Text ${lang ? ` ( ${lang} )` : ''}:`}</div>
                                        <div style={{whiteSpace: 'pre-line'}}>
                                            {this.props.sourceText}
                                        </div>
                                    </div>
                                    <div className="translated-text">
                                        <div className='header'>Translated Text:</div>
                                        <div style={{whiteSpace: 'pre-line'}}>
                                            {this.props.targetText}
                                        </div>
                                    </div>
                                </div>
                                <span className="translatedText-error-msg">{this.state.error}</span>
                            </div>
                        </div>
                        <div className="translatedText-footer">
                            <button type="button" className="translatedText-default-button" onClick={this.close}>Close</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

TranslatedTextDialog.propTypes = {
    sourceText: PropTypes.string.isRequired,
    sourceLanguage: PropTypes.string,
    targetText: PropTypes.string.isRequired
};

export default TranslatedTextDialog;


